<template>
    <div :class="{ 'date-of-birth-select': true, 'has-errors': errors.has( 'date_of_birth' ) }">
        <label class="date-label">Geboortedatum</label>
        <div class="row">
            <div class="col-4">
                <v-select class="date-inputs" name="day-of-birth" v-model="dayOfBirth" :selectValues="days" placeholder="dag" autocomplete="bday-day" tabindex="6"></v-select>
            </div>
            <div class="col-4">
                <v-select class="date-inputs" name="month-of-birth" v-model="monthOfBirth" :selectValues="months" :selectLabels="monthLabels" placeholder="maand" autocomplete="bday-month" tabindex="7"></v-select>
            </div>
            <div class="col-4">
                <v-select class="date-inputs" name="year-of-birth" v-model="yearOfBirth" :selectValues="years" placeholder="jaar" autocomplete="bday-year" tabindex="8"></v-select>
            </div>
        </div>
        <input type="hidden" name="date_of_birth" v-model="date_of_birth" v-validate="rules['date_of_birth']" />

        <span class="error">{{ errors.first( 'date_of_birth' ) }}</span>
    </div>
</template>

<style lang="scss" scoped>
    .date-label{
        display:block;
    }
    .date-inputs{
        display:block;
    }
</style>

<script>
    /* eslint-disable vue/prop-name-casing */

    import { rules } from '@/app/config';
    import { tracking } from '@/app/mixins';
    import CustomSelect from '@/app/components/form-elements/CustomSelect';

    export default {
        inject: ['$validator'],

        components: {
            'v-select': CustomSelect
        },

        mixins: [ tracking ],

        model: {
            prop: 'date_of_birth',
            event: 'change'
        },

        props: {
            date_of_birth: {
                type: String,
                default: null
            }
        },

        data()
        {
            return {
                rules: rules,

                days: [],
                months: [],
                monthLabels: [
                    '',
                    'januari',
                    'februari',
                    'maart',
                    'april',
                    'mei',
                    'juni',
                    'juli',
                    'augustus',
                    'september',
                    'oktober',
                    'november',
                    'december'
                ],
                years: [],

                dayOfBirth: '',
                monthOfBirth: '',
                yearOfBirth: ''
            };
        },

        watch: {
            'dayOfBirth': function( pVal )
            {
                this.trackEvent( 'Klik op input', 'Funnel events', 'Geboortedatum dag' );
                this.checkDate();
            },

            'monthOfBirth': function( pVal )
            {
                this.trackEvent( 'Klik op input', 'Funnel events', 'Geboortedatum maand' );
                this.checkDate();
            },

            'yearOfBirth': function( pVal )
            {
                this.trackEvent( 'Klik op input', 'Funnel events', 'Geboortedatum jaar' );
                this.checkDate();
            }
        },

        mounted()
        {
            for( let i = 0; i < 31; i++ )
            {
                this.days.push( i + 1 );
            }

            for( let i = 0; i < 12; i++ )
            {
                this.months.push( i + 1 );
            }

            for( let i = 2019; i > 1900; i-- )
            {
                this.years.push( i );
            }
        },

        methods: {
            checkDate()
            {
                if( this.dayOfBirth.length < 1 || this.monthOfBirth.length < 1 || this.yearOfBirth.length < 1 )
                {
                    return;
                }

                let date = new Date( ( '0' + this.dayOfBirth ).substr( -2 ) + '-' + ( '0' + this.monthOfBirth ).substr( -2 ) + '-' + this.yearOfBirth );
                if( isNaN( date.getTime() ) )
                {
                    // invalid
                }

                this.$emit( 'change', this.yearOfBirth + '-' + ( '0' + this.monthOfBirth ).substr( -2 ) + '-' + ( '0' + this.dayOfBirth ).substr( -2 ) );
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/components/form-elements/DateOfBirth.vue